import React from 'react';
import {
  Button,
  Icon,
  Table,
  Popup,
} from 'semantic-ui-react';
import _ from 'lodash';
import PropTypes from 'prop-types';

export default function ApprovalsCountTable({ isLoading, isRefetching, items, targets, onRefetch, title, onClick }) {
  const getProcessedData = itemsData => {
    const allCountries = _.map(itemsData, 'countries');
    const groupedByCountry = _.groupBy(_.flatten(allCountries), 'country');
    const statusCounts = _.map(groupedByCountry, group => {
      const totalApproved = _.sumBy(group, g => {
        const approved = _.find(g.statusCounts, ['status', 'APPROVED']);
        return _.get(approved, 'count', 0);
      });
      const totalRejected = _.sumBy(group, g => {
        const rejected = _.find(g.statusCounts, ['status', 'REJECTED']);
        return _.get(rejected, 'count', 0);
      });
      const approved = totalApproved;
      const rejected = totalRejected;
      return { country: _.get(group, '[0].country', '-'), approved, rejected };
    });
    const countryFilters = [
      { code: 'DE', name: 'Germany' },
      { code: 'FR', name: 'France' },
      { code: 'IT', name: 'Italy' },
      { code: 'ES', name: 'Spain' },
    ];

    return _.map(countryFilters, country => {
      const data = _.find(statusCounts, ['country', country.code]);
      return {
        country: country.name,
        countryCode: country.code,
        approved: _.get(data, 'approved', '-'),
        rejected: _.get(data, 'rejected', '-'),
      };
    });
  };
  const titleStyles = {
    cursor: onClick ? 'pointer' : 'default',
  };
  const infoIconStyles = {
    marginLeft: '5px',
    fontSize: '18',
  };
  return (<Table celled>
    <Table.Header>
      <Table.Row >
        {onClick &&
        <Popup
          content="Open details by date"
          position="top center"
          trigger={
            <Table.HeaderCell style={titleStyles} onClick={onClick} colSpan={4} textAlign="center">
              {title}
              <Icon name="info circle" style={infoIconStyles} />
            </Table.HeaderCell>
          }
        />}
        {!onClick && <Table.HeaderCell style={titleStyles} onClick={onClick} colSpan={4} textAlign="center">
          {title}
        </Table.HeaderCell>}
      </Table.Row>
      <Table.Row>
        <Table.HeaderCell>Country</Table.HeaderCell>
        <Table.HeaderCell>Approved</Table.HeaderCell>
        <Table.HeaderCell>Rejected</Table.HeaderCell>
        <Table.HeaderCell>Target</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
      {isLoading && (
        <Table.Row>
          <Table.Cell colSpan={4} textAlign="center">
          Loading...
          </Table.Cell>
        </Table.Row>
      )}
      {!_.isEmpty(items) &&
        _.map(getProcessedData(items), item => (<Table.Row key={item.country}>
          <Table.Cell>
            {item.country}
          </Table.Cell>
          <Table.Cell>
            {item.approved}
          </Table.Cell>
          <Table.Cell>
            {item.rejected}
          </Table.Cell>
          <Table.Cell>
            {_.get(targets, `${item.countryCode}`, '-')}
          </Table.Cell>
        </Table.Row>))
      }
      {
        !_.isEmpty(items) &&
        <Table.Row>
          <Table.Cell colSpan={4} textAlign="center">
            <Button disabled={isRefetching} loading={isRefetching} color="pink" onClick={onRefetch}>
              <Icon name="refresh" />
            Refresh data
            </Button>
          </Table.Cell>
        </Table.Row>
      }
      {_.isEmpty(items) && !isRefetching && !isLoading && (
        <Table.Row>
          <Table.Cell colSpan={4} textAlign="center">
            <div style={{ marginBottom: '10px' }}>There is no data</div>
            <Button disabled={isRefetching} loading={isRefetching} color="pink" onClick={onRefetch}>
              <Icon name="refresh" />
            Refresh data
            </Button>
          </Table.Cell>
        </Table.Row>
      )}
    </Table.Body>
  </Table>);
}

ApprovalsCountTable.propTypes = {
  isLoading: PropTypes.bool,
  isRefetching: PropTypes.bool,
  items: PropTypes.array,
  onRefetch: PropTypes.func,
  title: PropTypes.string,
  onClick: PropTypes.func,
  targets: PropTypes.object,
};

ApprovalsCountTable.defaultProps = {
  isLoading: false,
  isRefetching: false,
  items: [],
  onRefetch: _.noop,
  title: '',
  onClick: null,
  targets: {},
};



/** WEBPACK FOOTER **
 ** ./src/components/approval-count-table/index.js
 **/